$(document).ready(function () {
    new Swiper("#homeHeroList", {
        slidesPerView: 1,
        speed: 1000,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        autoplay: {
            delay: 2000,
            disableOnInteraction: false,
        },
    });
});
